import { GameObject } from "./GameObject";
import ResizableScene from "./ResizableScene";

export interface IComponent {
	update?(dt: number): void;
	physicsUpdate?(dt: number): void;
	destroy(): void;
}

export abstract class Component implements IComponent {
	obj: GameObject;
	scene: ResizableScene;
	enabled = true;

	constructor(obj: GameObject) {
		this.obj = obj;
		this.scene = obj.scene;
	}

	public update(_dt: number): void {
		return;
	}

	public physicsUpdate(_dt: number): void {
		return;
	}

	public preRender(): void {
		return;
	}

	public destroy(): void {
		return;
	}
}
